export default __webpack_public_path__ + "static/media/calendar.b0e8a212.svg";